/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as ThemesActions from "../../actions/themesActions";
import * as constants from "../../constants";

const selectThemeLogic = createLogic({
	type: ActionTypes.SELECT_THEME,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		//TODO: dispatch action for creating a loader
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});

				api.get(`/themes/${action.theme}`)
					.then(data => {
						//TODO: dispatch action for stopping loader
						dispatch(ThemesActions.selectThemeSuccess(data.data));
						done();
					})
					.catch(error => {
						//TODO: dispatch action for stopping loader
						dispatch(ThemesActions.selectThemeFailure(error));
						done();
					});
			});
	},
});

export default [selectThemeLogic];
